<template>
  <div
    v-if="urgentNotification"
    class="mw-notif-urgent-container d-flex justify-content-center"
  >
    <font-awesome-icon
      :icon="['fas', 'exclamation-circle']"
      class="mw-notif-urgent-icon mr-1"
    ></font-awesome-icon>
    <span
      class="mw-notif-urgent-message"
      v-html="sanitize(urgentNotification.message)"
    >
    </span>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { sanitize } from '@/plugins/dompurify';

export default {
  name: 'urgent-notification-side',
  data() {
    return {
      sanitize: sanitize,
    };
  },
  computed: mapState('webKnowledgeModule', ['urgentNotification']),
};
</script>
<style lang="scss" scoped>
.mw-notif-urgent-container {
  padding: 8px;
  border: 1px solid $red-mayday;
  border-radius: 4px;
  background-color: rgba($red-mayday, 0.1);

  .mw-notif-urgent-icon {
    color: $red-mayday;
  }
  .mw-notif-urgent-message {
    font-weight: 700;
    font-size: 0.8rem;
    color: #000000;
    max-height: calc(100vh - 262px);
    overflow: auto;
  }
}
</style>
